import { useMemo } from 'react';

export function BrandingPreview({ color, displayName, logoUrl }) {
  const cssVars = useMemo(() => ({
    '--brand-primary': color,
  }), [color]);

  return (
    <aside className="settings-branding-preview" aria-label="PDF cover preview">
      <div className="settings-branding-preview-label">PDF cover preview</div>
      <div
        className="settings-branding-preview-card"
        style={cssVars}
        data-testid="branding-preview"
        aria-hidden="true"
      >
        <div className="bp-cover">
          <header className="bp-cover-header">
            {logoUrl ? (
              <img src={logoUrl} alt="" className="bp-cover-logo" />
            ) : (
              <div className="bp-cover-logo-placeholder" />
            )}
            <div className="bp-cover-org">{displayName}</div>
          </header>

          <div className="bp-cover-rule" />

          <div className="bp-cover-body">
            <div className="bp-cover-eyebrow">Schedule Health Report</div>
            <div className="bp-cover-title">Project Name Here</div>
            <div className="bp-cover-meta">
              <span>Data date · 2026-04-04</span>
              <span>Report ID · CW-2026-0001</span>
            </div>
          </div>

          <div className="bp-cover-gauge">
            <div className="bp-cover-gauge-arc">
              <div className="bp-cover-gauge-fill" />
            </div>
            <div className="bp-cover-gauge-score">
              <span className="bp-cover-gauge-num">87</span>
              <span className="bp-cover-gauge-out">/ 100</span>
            </div>
            <div className="bp-cover-gauge-label">Overall score</div>
          </div>

          <footer className="bp-cover-footer">
            <span>Generated with CritWise</span>
            <span className="bp-cover-footer-dot">·</span>
            <span>{displayName}</span>
          </footer>
        </div>
      </div>
    </aside>
  );
}
